import { Injectable } from "@angular/core";
import { Observable, catchError, from, map, of, tap } from "rxjs";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { DialogShareInWebDesktopComponent } from "@app/presentation/components/dialog-share-in-web-desktop/dialog-share-in-web-desktop.component";

@Injectable({ providedIn: "root" })
export class ShareMessageMobileWeb {
  constructor(private modalService: NgbModal) {}

  execute(message: string, url: string): Observable<string> {
    let shareData = {
      title: "",
      text: message,
      url: url,
    };
    // The Web Share API is not available in every mobile web context: in-app
    // browsers (Facebook, Instagram…) and some Android/iOS WebViews don't expose
    // navigator.share. Calling it there throws "navigator.share is not a
    // function" synchronously (so the catchError below never runs). Feature-
    // detect and fall back to the copy-link dialog, like the desktop flow.
    if (typeof navigator.share !== "function") {
      return of("mobile-web-fallback").pipe(
        tap(() => this.#openShareDialog(message, url)),
        catchError((err) => of("error not catched"))
      );
    }
    //For analytics we need to return the platform were it's shared
    return from(navigator.share(shareData)).pipe(
      map((ret) => "mobile-web"),
      catchError((err) => of("error not catched"))
    );
  }

  #openShareDialog(message: string, url: string) {
    const ref = this.modalService.open(DialogShareInWebDesktopComponent, {
      centered: true,
    });
    ref.componentInstance.data = {
      message: message,
      url: url,
    };
  }
}
